export default "__VITE_ASSET__CNfxtsOO__"